import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class ModbusDataPoint {
  constructor () {
    instance = instance || this

    this._table = DB.modbusDataPoint

    return instance
  }

  async add (options) {
    return this._table.add({
      id: newGuid(),
      modbusDataId: options.modbusDataId,
      offset: options.offset,
      regNum: options.regNum
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async all () {
    return this._table.toArray()
  }

  async update (id, data) {
    return this._table.update(id, {
      offset: data.offset,
      regNum: data.regNum
    })
  }

  async delete (id) {
    return this._table.delete(id)
  }
}



// WEBPACK FOOTER //
// ./src/models/modbus-data-point.js